import { directPurchaseStore } from '~/common/stores/ui/directPurchase';

// Detect a Qualtrics Banner and make changes for the events
export const qualtricsBannerObserver = (showLoading, callback) => {
    // Select the node that will be observed for mutations
    const targetNode = document.body;

    // Config shows options for the observer (which mutations to observe)
    const config = { childList: true };

    // Call to close Observer for the Qualtrics banner events
    const callbackForCloseObserver = (element, observer) => {
        // Check if the banner is present using the class name of the banner in both dev and Prod envs
        if (element?.classList?.value === 'QSIInfoBar SI_2fXBGNhq2a0vVNI_InfoBarContainer' || element?.classList?.value === 'QSIInfoBar SI_efX0lHgGG9WKNsq_InfoBarContainer') {
            setTimeout(() => {
                // eslint-disable-next-line no-param-reassign
                element.style.bottom = '0px';
            }, 2000);
            if (showLoading) {
                directPurchaseStore.setQualtricsBannerShowing(true);
            }

            observer.disconnect();
        }
    };

    // Callback function to execute when mutations are observed
    const mutationCallback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((element) => {
                    callbackForCloseObserver(element, observer);
                });
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(mutationCallback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

    // Call the callback function with some timeout
    if (callback) {
        setTimeout(() => {
            callback();
        }, 4000);
    }
};

export const qualtricsBannerInit = () => {
    const script = document.createElement('script');
    if (ENV === 'production') {
        script.innerHTML = `(function(){var g=function(e,h,f,g){
            this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};
            this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048E5);b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};
            this.check=function(){var a=this.get(f);if(a)a=a.split(":");else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case "v":return!1;case "r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};
            this.go=function(){if(this.check()){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)}};
            this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
            try{(new g(100,"r","QSI_S_ZN_4UEikaUZpuGCZ7w","https://zn4ueikauzpugcz7w-logmeinvoc.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_4UEikaUZpuGCZ7w")).start()}catch(i){}})();`;
    } else {
        script.innerHTML = `(function(){var g=function(e,h,f,g){
            this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};
            this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048E5);b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};
            this.check=function(){var a=this.get(f);if(a)a=a.split(":");else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case "v":return!1;case "r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};
            this.go=function(){if(this.check()){var a=document.createElement("script");a.type="text/javascript";a.src=g;document.body&&document.body.appendChild(a)}};
            this.start=function(){var t=this;"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",function(){t.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){t.go()}):t.go()};};
            try{(new g(100,"r","QSI_S_ZN_cFIjCkmWIBvsKW2","https://zncfijckmwibvskw2-logmeinvoc.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_cFIjCkmWIBvsKW2")).start()}catch(i){}})()`;
    }
    document.head.prepend(script);
};
